import axios from 'axios';

const headers = {
    headers: {
        "x-cards-request-id": pageRequestId
    }
};

const getTopCategories = async (pageId) => {
    try {
        const resp = await axios.post('/api/cards/top-categories', { pageId: pageId }, headers);
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
};

const getDisclosure = async (pageId) => {
    try {
        const resp = await axios.post('/api/page/get-page', { pageId: pageId }, headers);
        return resp;
    } catch (e) {
        console.error(e);
    }
}

const getSavedCards = async (cards) => {
    try {
        var url = window.location.href.includes("/compliance/") ? '/api/cards/compliance/saved-cards' : '/api/cards/saved-cards';
        const resp = await axios.post(url, cards, headers);
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
};

const getTopCards = async (cards, categoryId) => {
    try {
        let url = '/api/cards/top-cards';
        if (categoryId) {
            url += `?category=${categoryId}`;
        }
        const resp = await axios.post(url, cards, headers);
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
};

const getCard = async (siteId, cardId) => {
    try {
        console.log(siteId, cardId);
        const resp = await axios.get(`/api/cards/get-card?siteId=${siteId}&cardId=${cardId}`);
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
}

export default {
    getTopCategories,
    getSavedCards,
    getTopCards,
    getCard,
    getDisclosure
}
